import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

const FAQs = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFAQs();
  }, []);

  const fetchFAQs = async () => {
    try {
      const response = await axios.get(`http://3.109.108.187/api/faqs`);
      setFaqs(response.data);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    } finally {
      setLoading(false);
    }
  };

  const defaultFAQs = [
    {
      id: '1',
      question: 'What is Amrut Mahotsav?',
      answer: 'Amrut Mahotsav is a year-long celebration marking 75 years of JG Group\'s excellence in education and service to the nation. It includes various cultural, academic, and social events throughout the year.',
      order: 1
    },
    {
      id: '2',
      question: 'How can I register for events?',
      answer: 'You can register for events through our online registration form. Simply visit the Registration page, fill in your details, select the event you wish to attend, and submit the form.',
      order: 2
    },
    {
      id: '3',
      question: 'Are the events open to everyone?',
      answer: 'Yes! While some events are specifically for students and alumni, many events are open to the general public. Please check individual event details for specific eligibility criteria.',
      order: 3
    },
    {
      id: '4',
      question: 'Is there a registration fee?',
      answer: 'Most events are free for students and alumni. Some special events may have a nominal registration fee, which will be clearly mentioned during registration.',
      order: 4
    },
    {
      id: '5',
      question: 'How can I stay updated about upcoming events?',
      answer: 'You can stay updated by visiting our Live Updates page regularly, following our social media channels, or subscribing to our newsletter.',
      order: 5
    },
  ];

  const displayFAQs = faqs.length > 0 ? faqs : defaultFAQs;

  return (
    <div className="min-h-screen bg-white" data-testid="faqs-page">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[300px] mt-20" data-testid="faqs-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-green-600"></div>
        <div className="relative h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">FAQs</h1>
            <p className="text-xl text-white/90">Find answers to commonly asked questions</p>
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="section-spacing" data-testid="faqs-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-20">
              <div className="inline-block w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="mt-4 text-gray-600">Loading FAQs...</p>
            </div>
          ) : (
            <Accordion type="single" collapsible className="space-y-4" data-testid="faqs-accordion">
              {displayFAQs.map((faq, index) => (
                <AccordionItem key={faq.id} value={`faq-${index}`} className="bg-white rounded-xl shadow-lg px-6 border border-gray-100" data-testid={`faq-item-${index}`}>
                  <AccordionTrigger className="text-left font-bold text-gray-800 hover:text-orange-600 py-6">
                    <span className="pr-4">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </div>
      </section>

      {/* Contact Section */}
      <section className="section-spacing bg-gradient-to-br from-orange-50 to-white" data-testid="faqs-contact">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Still have questions?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Feel free to reach out to us. We're here to help!
          </p>
          <a href="/contact" data-testid="faqs-contact-btn">
            <button className="btn-primary">
              Contact Us
            </button>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQs;